import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Space, Typography, Divider } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import { useUser } from '../../services/providers/UserProvider';
import { FormattedMessage } from 'react-intl';
import AvatarUser from './common/AvatarUser';
import SelectorLanguages from './common/SelectorLanguages';
import logo from '../../../public/img/logo.svg';
const Extra = () => {
  const { user } = useUser();
  const location = useLocation();

  return (
    <Space split={<Divider type="vertical" />}>
      <SelectorLanguages />
      {user.isLogged && location?.pathname !== '/login' && (
        <>
          <AvatarUser />
          <Typography.Text>
            <FormattedMessage id="dashboard.welcomeback" />{' '}
            <b>{user.username}</b>
          </Typography.Text>
        </>
      )}
    </Space>
  );
};

const Header = () => {
  return (
    <PageHeader
      style={{ zIndex: 10, borderBottom: ' 1px solid #E8E8E8' }}
      title={
        <Link to="/dashboard/workorders">
          <img src={logo} alt="bolttech" style={{ height: '29px' }} />
        </Link>
      }
      ghost={false}
      extra={<Extra />}
    />
  );
};

export default Header;
